<main class="login-container">

    <div class="background-gif"></div>

    <div>
        <div class="login-card">
            <div class="logo-container">
                <img src="assets/images/Logo/login-logo.svg" alt="CSQ Logo" class="logo">
            </div>
            <h1 class="welcome-text">Experience Portal</h1>
            <img src="assets/images/fi-rr-lock.svg" />
            <h2 class="verification-title">Verify your identity</h2>
            <p class="verification-text">
                A verification code has been sent to your registered email. Please enter it below.
            </p>

            <form [formGroup]="verificationForm" (ngSubmit)="onVerify()" style="width: 100%;">
                <div class="code-input-wrapper">
                    <input *ngFor="let digit of digits; let i = index" #inputRefs type="text" maxlength="1"
                        autocomplete="off" [formControlName]="digit" [class.disabled]="isLoading"
                        (input)="onOtpInput($event, i)" (keydown)="onOtpKeyDown($event, i)"
                        (paste)="handlePaste($event)" [autofocus]="i === 0" [ngClass]="{
            'code-input': true,
            'invalid-input': isInvalidOtp || (verificationForm.get(digit)?.invalid && verificationForm.get(digit)?.touched)
          }" />
                </div>

                <div *ngIf="isInvalidOtp || (verificationForm.invalid && submitted)"
                    class="login-error-message text-center">
                    {{ errorMessage || 'All fields are required and must be digits' }}
                </div>

                <div class="resend-link">
                    <span>Didn’t receive a code?</span>
                    <a href="javascript:void(0)" (click)="resendCode()" [class.disabled]="isResendDisabled || isLoading"
                        [attr.aria-disabled]="isResendDisabled || isLoading" *ngIf="!isResendDisabled">
                        Resend code
                    </a>
                    <span *ngIf="isResendDisabled" class="timer-text">
                        Resend available in {{ resendTimer }}s
                    </span>
                </div>


                <button type="submit" class="reset-button" [class.disabled]="isLoading">
                    <ng-container *ngIf="!isLoading">Verify</ng-container>
                    <ng-container *ngIf="isLoading">
                        Verify <div class="spinner"></div>
                    </ng-container>
                </button>
            </form>
        </div>
    </div>

    <p class="login-subtext">
        Should you require immediate assistance, please contact CSQ at
        <a href="tel:1800798488" class="contact-phone">1800 798 488</a> or
        <br>
        email us at <a href="mailto:constructionpathways@csq.org.au"
            class="contact-email">constructionpathways&#64;csq.org.au</a>
    </p>
</main>